module.exports = __webpack_public_path__ + "img/ic_mine_nor.3159f3d6.svg";